import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TuiScrollbar, TuiScrollable, TuiButton, TuiHint } from '@taiga-ui/core';
import { TranslateModule } from '@ngx-translate/core';

import { MessengerSettingsComponent } from './settings.component';
import { NotificationsModule } from './notifications';

@NgModule({
  declarations: [MessengerSettingsComponent],
  imports: [
    CommonModule,
    NotificationsModule,
    TuiScrollbar,
    TuiScrollable,
    TuiButton,
    ...TuiHint,
    TranslateModule,
    RouterModule,
  ],
  exports: [MessengerSettingsComponent],
})
export class MessengerSettingsModule {}
